/* eslint-disable no-extra-parens */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { Suspense, lazy } from 'react';
import ngDeps from '../../common/utilities/ngDependencies';
import { withScreenSize } from '../common/utilities/withScreenSize.jsx';

const HurricaneLandingPage = lazy(() => import('./hurricaneLandingPage'));

export const HurricaneLandingPageLazy = () => {
    return (
        <Suspense fallback={<LoadingMarkup />}>
            <HurricaneLandingPage />
        </Suspense>
    );
};

interface LoadingMarkupProps {
    isDesktop: boolean;
}

// This will help maintain page structure while we fetch chunks, hence preventing layout shifts and harming out Cumulative Layout Shift score.
const LoadingMarkup = withScreenSize(({ isDesktop }: LoadingMarkupProps) => {
    return (
        <div>
            <div className='hurricane-landing'>

                <div className='hurricane-landing__ad__wrapper'>
                    <div className='hurricane_landing_ad_container'>
                        {
                            !isDesktop
                                ? <div className='hurricane_banner_ad'></div>
                                : null
                        }
                        
                    </div>
                </div>

                <section className='hurricane-info-section'>
                    <div className='hurricane-info-wrapper'>
                        <h1 className='hurricane-page-header'>
                            { (ngDeps as any)?.user?.ActiveLocation?.Locality?.DisplayCompositeName
                                ? `Hurricane Tracker - ${(ngDeps as any)?.user?.ActiveLocation?.Locality?.DisplayCompositeName}`
                                : 'Hurricane Tracker'
                            }
                        </h1>
                        <div className='hurricane-info'></div>
                        <div className='hurricane-map'></div>
                        <div className='hurricane-info-ad-mobile'>
                            <div style={{ width: 300, height: 250 }}></div>
                        </div>
                    </div>
                </section>

                <section className='hurricane-stories-section'>
                    <div className='hurricane-stories-wrapper'>
                        <div className='hurricane-stories-header'>Top Stories</div>
                        {/* Desktop/Tablet Stories List Markup */}
                        <div className='hurricane-stories'>
                            <div className='hurricane-stories-list'>
                                {
                                    Array.from(Array(6).keys()).map((index) => {
                                        return <div key={`${index}_bottom_list`} className='hurricane-story-item'></div>;
                                    })
                                }
                            </div>
                        </div>
                        {/* @* Mobile mark-up above ad unit *@ */}
                        <div className='hurricane-stories-list-top'>
                            <div className='hurricane-stories-list'>
                                {
                                    Array.from(Array(3).keys()).map((index) => {
                                        return <div key={`${index}_stories_top_list`} className='hurricane-story-item'></div>;
                                    })
                                }
                            </div>
                        </div>
                        {/* End Mobilie stories top section markup */}
                        <div className='hurricane-stories-ad-container'>
                            <div className='hurricane-stories-ad'></div>
                        </div>
                        {/* Mobile Stories mark up bottom section */}
                        <div className='hurricane-stories-list-bottom'>
                            <div className='hurricane-stories-list'>
                                {
                                    Array.from(Array(3).keys()).map((index) => {
                                        return <div key={`${index}_bottom_list`} className='hurricane-story-item'></div>;
                                    })
                                }
                            </div>
                        </div>
                        {/* End Mobilie stories bottom section markup */}
                    </div>
                </section>
            </div>
        </div>
    );
});

